import type React from 'react';

import type { IdHeaderTagDto, IdPlacementDto, IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { RequestErrorNotification } from 'src/hooks/useRequestErrorNotification';

export interface TagDetailsRouteParams {
  integrationType: IntegrationType;
  headerTagId: IdHeaderTagDto;
  placementId?: IdPlacementDto;
}

export type ActionPopup<T> = {
  headerTagId: IdHeaderTagDto;
  setCurrentItems: React.Dispatch<React.SetStateAction<{ responseCode: 200; data: T; headers: null }>>;
  onFail: RequestErrorNotification;
};

export enum TagDetailsTab {
  placements = 'placements',
  rawScripts = 'raw-scripts',
  disableRules = 'disable-rules',
  dynamicPlacements = 'dynamic-placements',
  floorRule = 'floor-rule',
  live = 'live',
}

export enum PlacementDetailsTab {
  settings = 'settings',
  live = 'live',
}
